export const videoMimeTypes = ["video/mp4"] as const;
